<template>
  <v-layout     align-center>
    <v-flex text-right>
      <p>
        <strong>{{ name(item) }}</strong>
      </p>
    </v-flex>
    <v-flex v-if="item.category" text-left>
      <p class="ma-0 total-jobs">
        (
        <span class="hidden-xs-only">{{ item.category }} |</span>
        {{ numOfJobs(item) }} משרות )
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
import { getItemName, getItemNumOfJobs } from '@/lib/item'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    name(item) { return getItemName(item) },
    numOfJobs(item) { return getItemNumOfJobs(item) }
  }
}
</script>

<style lang="scss" scoped>
p {
  font-size: 12px;
}

p:nth-child(2) {
  font-size: 10px;
}

.total-jobs {
  color: #a2a3a4;
}

@media screen and (min-width: 400px) {
  p {
    font-size: 13px;
  }

  p:nth-child(2) {
    font-size: 10px;
  }
}
</style>
